import { FAST_BUZZER_DEFINITION } from "./fast-buzzer-definition.js";
import { GUESS_THE_SONG_DEFINITION } from "./guess-the-song-definition.js";
import { ODD_ONE_OUT_DEFINITION } from "./odd-one-out-definition.js";
import { PITCH_CHALLENGE_DEFINITION } from "./pitch-challenge-definition.js";
import { QUIZ_BUZZER_DEFINITION } from "./quiz-buzzer-definition.js";
import { TRUE_OR_FALSE_DEFINITION } from "./true-or-false-definition.js";
import { EVENT_PACES } from "./game-definition.js";
import { ANAGRAM_SPRINT_DEFINITION, MATH_SPRINT_DEFINITION, NUMBER_SEQUENCE_DEFINITION, EMOJI_RIDDLE_DEFINITION } from "./party-puzzle-definitions.js";
export { EVENT_PACES };
export const GAME_KEYS = ["FAST_BUZZER", "QUIZ_BUZZER", "GUESS_THE_SONG", "PITCH_CHALLENGE", "TRUE_OR_FALSE", "ODD_ONE_OUT", "ANAGRAM_SPRINT", "MATH_SPRINT", "NUMBER_SEQUENCE", "EMOJI_RIDDLE"];
export const MAX_EVENT_GAMES = 10;
export const ROOM_LANGUAGES = ["it", "en"];
export function isRoomLanguage(value) {
    return typeof value === "string" && ROOM_LANGUAGES.includes(value);
}
export const GAME_DEFINITIONS = Object.freeze({
    FAST_BUZZER: FAST_BUZZER_DEFINITION,
    QUIZ_BUZZER: QUIZ_BUZZER_DEFINITION,
    GUESS_THE_SONG: GUESS_THE_SONG_DEFINITION,
    PITCH_CHALLENGE: PITCH_CHALLENGE_DEFINITION,
    TRUE_OR_FALSE: TRUE_OR_FALSE_DEFINITION,
    ODD_ONE_OUT: ODD_ONE_OUT_DEFINITION,
    ANAGRAM_SPRINT: ANAGRAM_SPRINT_DEFINITION,
    MATH_SPRINT: MATH_SPRINT_DEFINITION,
    NUMBER_SEQUENCE: NUMBER_SEQUENCE_DEFINITION,
    EMOJI_RIDDLE: EMOJI_RIDDLE_DEFINITION
});
export const GAME_CATALOG = Object.freeze(GAME_KEYS.map((id) => {
    const definition = GAME_DEFINITIONS[id];
    return Object.freeze({
        id,
        slug: definition.metadata.slug,
        name: definition.metadata.name,
        description: definition.metadata.description,
        icon: definition.metadata.icon,
        status: definition.metadata.catalogStatus,
        maturity: definition.metadata.maturity,
        hostAccess: definition.metadata.hostAccess,
        minimumPlayers: definition.metadata.minimumPlayers,
        maximumPlayers: definition.metadata.maximumPlayers,
        route: definition.views,
        supportedConfiguration: definition.supportedConfiguration,
        capabilities: definition.metadata.capabilities
    });
}));
export function getCatalogEntry(gameKey) {
    const entry = GAME_CATALOG.find((game) => game.id === gameKey);
    if (!entry)
        throw new Error(`Missing catalog entry: ${gameKey}`);
    return entry;
}
export function isGameKey(value) {
    return typeof value === "string" && GAME_KEYS.includes(value);
}
export function getGameDefinition(key) {
    return GAME_DEFINITIONS[key];
}
export function getGameConfiguration(gameKey, pace) {
    const definition = GAME_DEFINITIONS[gameKey];
    const profile = definition.configurationProfiles[pace];
    return Object.freeze({ ...definition.initialConfig, ...profile.configuration });
}
export function estimateEventMinutes(gameKeys, pace) {
    return gameKeys.reduce((total, gameKey) => total + GAME_DEFINITIONS[gameKey].configurationProfiles[pace].estimatedMinutes, 0);
}
//# sourceMappingURL=games.js.map